import { AlertCard, TextInput } from "@caprikorn/dynamo-ui";
import type { FC } from "react";
import { Controller } from "react-hook-form";

import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./PerimeterForm.module.css";
import type { PerimeterFormProps } from "./PerimeterForm.types";

export const PerimeterForm: FC<PerimeterFormProps> = ({ control }) => {
  const { t } = useCustomTranslation("main");

  return (
    <div
      className={classes.container}
      data-testid="PerimeterForm-RMFormWrapper"
    >
      <AlertCard
        aria-label={t("requestDrawer.steps.perimeter.warning")}
        size="sm"
        variant="info"
      >
        {t("requestDrawer.steps.perimeter.warning")}
      </AlertCard>
      <Controller
        control={control}
        name="perimeterForm.perimeter"
        render={({ field }) => (
          <TextInput
            className={classes.input}
            disabled
            label={t("requestDrawer.steps.perimeter.perimeter")}
            onChange={() => {}} // Empty because always disabled
            value={field.value}
          />
        )}
      />
      <Controller
        control={control}
        name="perimeterForm.customer"
        render={({ field }) => (
          <TextInput
            className={classes.input}
            disabled
            label={t("requestDrawer.steps.perimeter.customer")}
            onChange={() => {}} // Empty because always disabled
            value={field.value}
          />
        )}
      />
      <Controller
        control={control}
        name="perimeterForm.contract"
        render={({ field }) => (
          <TextInput
            className={classes.input}
            disabled
            label={t("requestDrawer.steps.perimeter.contract")}
            onChange={() => {}} // Empty because always disabled
            value={field.value}
          />
        )}
      />

      <Controller
        control={control}
        name="perimeterForm.site"
        render={({ field }) => (
          <TextInput
            className={classes.input}
            disabled
            label={t("requestDrawer.steps.perimeter.site")}
            onChange={() => {}} // Empty because always disabled
            value={field.value}
          />
        )}
      />
    </div>
  );
};
